import { createStore } from 'redux'
import reducer from 'redux/reducers'

export default createStore(reducer)
